import { FC } from 'react';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';

import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  return (
    <InnerWrapper>
      <GroupedDocsTable
        entityName="my-documents-for-sign"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'for_sign',
        }}
      />
    </InnerWrapper>
  );
};

export default Screen;
